import React from 'react';
import classes from './HandlingUserData.module.css';

const en = (props) => (
  <div className={classes.Content}>
    {props.indexPage
      ? <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}><b>Download Data</b></p>
        <p>To download your data go to the following page<br />
          Settings > Options > Data Management > Download Data
        </p><br />
        <div className={classes.HrLine} />
        <br />
      </div>
      : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}><b>Request Data Deletion</b></p><br />
    <p>To request data deletion, follow the steps below:</p><br />
    <p>Go to Contact Us Page <br />
      Select option "Delete Account And All My Data." <br />
      Press Submit <br /><br />
    </p>
    <p>Our CS team will within 24 hours delete all your data.</p>
  </div>
);

export default en;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/en.js